import React from 'react';
import './TextArea.css';

interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  error?: string;
}

const TextArea: React.FC<TextAreaProps> = ({ 
  label, 
  error, 
  id, 
  className = '', 
  ...props 
}) => {
  const textareaId = id || `textarea-${label.toLowerCase().replace(/\s+/g, '-')}`;
  
  return (
    <div className={`form-control ${error ? 'has-error' : ''} ${className}`}>
      <label htmlFor={textareaId} className="form-label">
        {label}
      </label>
      <textarea 
        id={textareaId}
        className="form-textarea"
        {...props}
      />
      {error && <div className="form-error">{error}</div>}
    </div>
  );
};

export default TextArea; 